import moment from 'moment';

const Footer = () => (
  <footer className="footer">
    <div className="container-fluid">
      <div className="row">
        <div className="col-md-6">
          2018 - {moment().format('YYYY')} © Qvanti
        </div>
        <div className="col-md-6">
          <div className="text-md-end footer-links d-none d-md-block" />
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
